import { Component, Input, OnInit,Inject, PLATFORM_ID  } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EnvService } from 'src/app/services/env.service';
import { editorsList } from 'src/interface/editorial-board';

@Component({
  selector: 'app-view-editor-details',
  templateUrl: './view-editor-details.component.html',
  styleUrls: ['./view-editor-details.component.scss']
})
export class ViewEditorDetailsComponent implements OnInit {
  @Input() details: editorsList
  editorsImageUrl: string;
  constructor(public activeModal: NgbActiveModal, private EnvService: EnvService,@Inject(PLATFORM_ID) private platformId: any) {
  }
  ngOnInit(): void {
    this.editorsImageUrl = this.EnvService.editorialImage;
  }

  openOrcidLink(orcid: string) {
    if (isPlatformBrowser(this.platformId)) {
    window.open('https://orcid.org/' + orcid, 'Orcid Link', 'resizeable,height=800,width=600');
    }
  }
  
  ensureHttps(url: string): string {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return 'https://' + url;
    }
    return url;
  }
  checkProfesor(data: string) {
    return data.includes('Professor') ? 'PROFESSOR' : '';
    
  }
  checkName(data: string) {
    return data.replace('Professor', '').trim().toUpperCase();
 
  }
}
